import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as DataService from '../service/data-info-chart/requestsUtil';
import { BUSINESS_UNIT } from '../utils/constants';
import CorporateTools from '../components/corporateTools';


class Places extends Component {

  constructor(props) {
    super(props);
    this.getBusinessUnits = this.getBusinessUnits.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateBusinessUnitInSearch = this.updateBusinessUnitInSearch.bind(this);
    this.clearBusinessUnitInSearch = this.clearBusinessUnitInSearch.bind(this);
    this.keyPress = this.keyPress.bind(this);
    this.state = {
      places: [],
      search: '',
      isSearching: false,
      loaded: false,
      key: 0,
    };
  }

  keyPress(e){
    if(e.keyCode === 13){
      this.updateBusinessUnitInSearch();
    }
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    console.log(evt.target.value)
    this.setState({ [name]: value });
  }

  componentDidMount() {
    this.getBusinessUnits(false);
  }

  getBusinessUnits(isSearching){

    let bu = isSearching ? this.state.search : '';

    DataService.getFetch(BUSINESS_UNIT + '/' + bu)
      .then((data) => {
        this.setState({
          places: data,
          loaded: true,
          key: Math.random(),
        });
      });
  }

  productsLoop() {
    return this.state.places.map((place) => {
      return (
        <div className="col-md-4 col-3" key={place.id}>
          <Link to={{pathname: this.props.profile + place.name, state: {kpi: place.kpi, kpiMonitor: place.kpiMonitor, kpiStrategy: place.kpiStrategy}}}>
            <div className="product-single tool">
              <img id={place.name} src={place.image} alt=" " className="img-places"/>
              <h5>{place.name}</h5>
            </div>
          </Link>
        </div>
      );
    });
  }

  updateBusinessUnitInSearch(){
    this.getBusinessUnits(true);
  }

  clearBusinessUnitInSearch(){
    this.getBusinessUnits(false)
  }

  render() {
    return (
      <div className="container-fluid">
        <div className={'row'}>
          <div className={'col-md-6 pl-0'}>
            <div className={'container-fluid m-2'}>
              <div className={'title-places'}>
                Corporativo Estrategas
              </div>
              <CorporateTools/>
            </div>
          </div>
          <div className={'col-md-6 pl-0'}>
            <div className={'container-fluid m-2 readmin-products'}>
              <div className={'title-places'}>
                Operaciones Estrategas
              </div>
              <div className="mb-3">
                <div className="form-row align-items-center">
                  <div className="col-8 text-center">
                    <input type="text" className="form-control" name="search" onKeyDown={this.keyPress} onChange={this.handleChange} placeholder="Buscar unidad de negocio..." />
                  </div>
                  <div className="col-2 text-center">
                    <button className="btn btn-primary" onClick={this.updateBusinessUnitInSearch}>Buscar</button>
                  </div>
                  <div className="col-2 text-center">
                    <button className="btn btn-secondary" onClick={this.clearBusinessUnitInSearch}>Limpiar</button>
                  </div>
                </div>
              </div>
              <div className="row" key={this.state.key}>
                {this.productsLoop()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Places;



// WEBPACK FOOTER //
// ./src/containers/places.js